import { Typography, Arrange } from "@fullscript/aviary-web";
import { faCanadianMapleLeaf } from "@fullscript/free-brands-svg-icons";
import { faFlagUsa } from "@fullscript/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";

import { Page } from "@unauthenticated/signupSignin/components/Page/Page";
import { PageContent } from "@unauthenticated/signupSignin/components/PageContent/PageContent";
import { l } from "@unauthenticated/signupSignin/locales/i18n";
import { RegionTile } from "@unauthenticated/signupSignin/scenes/RegionSelectorPage/RegionTile/RegionTile";

import * as styles from "./RegionSelectorPage.styles";

const RegionSelectorPage = () => {
  const { t } = useTranslation();

  return (
    <Page>
      <PageContent>
        <Arrange isVertical alignment="center" gap="xlarge">
          <Typography variant="h2" as="h1">
            {t(l.regionSelector.title)}
          </Typography>
          <Arrange gap="medium" isWrapped={false} alignment="stretch" customCss={styles.tileGrid}>
            <RegionTile
              region="us"
              label={t(l.regionSelector.us)}
              content={t(l.regionSelector.usSubtitle)}
              icon={{ icon: faFlagUsa }}
            />
            <RegionTile
              region="ca"
              label={t(l.regionSelector.ca)}
              content={t(l.regionSelector.caSubtitle)}
              icon={{ icon: faCanadianMapleLeaf }}
            />
          </Arrange>
        </Arrange>
      </PageContent>
    </Page>
  );
};

export { RegionSelectorPage };
